(function () {
  'use strict';

  angular
    .module('individualFlyingHours')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('individualFlyingHours', {
        url: '/individual-flying-hours',
        views: {
          'individualFlyingHoursView': {
          templateUrl: 'individual-flying-hours/views/individual-flying-hours.tpl.html',
          controller: 'IndividualFlyingHoursCtrl',
          controllerAs: 'individualFlyingHours'
        }
      }
      });
  }
}());
